/* Server-rendered metafield/inventory values remain the source of truth. */
(() => {
  if (customElements.get('nn-fomo-bar')) return;
  let floating = null;
  let floatingFrame = 0;
  let followUntil = 0;

  function scheduleFloating() {
    if (!floatingFrame && window.requestAnimationFrame) floatingFrame = window.requestAnimationFrame(updateFloating);
  }

  function wakeFloating() {
    followUntil = Date.now() + 400;
    scheduleFloating();
  }

  function visibleBottom(element) {
    if (!element) return 0;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.visibility === 'hidden' || style.display === 'none' || rect.top >= window.innerHeight ? 0 : Math.max(0, Math.min(window.innerHeight, rect.bottom));
  }

  function updateFloating() {
    floatingFrame = 0;
    const top = Math.max(visibleBottom(document.querySelector('store-header')), visibleBottom(document.querySelector('height-observer[variable="announcement-bar"]')));
    const source = !document.hidden && Array.from(document.querySelectorAll('nn-fomo-bar[data-placement="gallery"][data-pdp-sticky-mode]')).find(bar => {
      if (bar.hidden || bar.hasAttribute('data-loading')) return false;
      const enabled = bar.dataset.pdpStickyMode === 'all' || bar.dataset.pdpStickyMode === 'mobile' && window.matchMedia('(max-width: 699px)').matches;
      if (!enabled || window.getComputedStyle(bar).visibility === 'hidden') return false;
      const rect = bar.getBoundingClientRect();
      // Do not show a copy merely because the gallery starts below the fold.
      return rect.width > 0 && rect.height > 0 && rect.bottom <= top;
    });
    if (!source) {
      if (floating) floating.hidden = true;
      return;
    }
    if (!floating) {
      floating = document.createElement('div');
      floating.setAttribute('data-fomo-floating', '');
      floating.hidden = true;
      document.body.append(floating);
    }
    let copy = floating.querySelector('nn-fomo-bar');
    if (copy?.sourceBar !== source) {
      copy?.remove();
      copy = source.cloneNode(true);
      copy.sourceBar = source;
      copy.dataset.placement = 'floating';
      delete copy.dataset.formId;
      delete copy.dataset.fomoKey;
      delete copy.dataset.pdpStickyMode;
      floating.append(copy);
    } else if (copy.contentHTML !== source.innerHTML) {
      // A pause toggle may already have updated both controls; preserve focus and animation nodes.
      if (copy.innerHTML !== source.innerHTML) copy.innerHTML = source.innerHTML;
      copy.contentHTML = source.innerHTML;
    }
    copy.hidden = false;
    if (copy.dataset.variantId !== source.dataset.variantId) copy.dataset.variantId = source.dataset.variantId;
    copy.toggleAttribute('data-motion-paused', source.hasAttribute('data-motion-paused'));
    copy.syncMotionControl();
    if (floating.style.top !== `${top}px`) floating.style.top = `${top}px`;
    floating.hidden = false;
    // Follow the header's 200ms transitions, then stop sampling until something changes.
    if (Date.now() < followUntil) scheduleFloating();
  }

  class NNFomoBar extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.contentHTML = this.innerHTML;
      this.addEventListener('click', event => {
        if (!event.target.closest('[data-fomo-motion-toggle]')) return;
        event.preventDefault();
        event.stopPropagation();
        const source = this.sourceBar || this;
        source.toggleAttribute('data-motion-paused');
        source.syncMotionControl();
        this.toggleAttribute('data-motion-paused', source.hasAttribute('data-motion-paused'));
        this.syncMotionControl();
        wakeFloating();
      }, { signal: this.controller.signal });
      this.syncMotionControl();
      wakeFloating();
      const form = document.getElementById(this.dataset.formId);
      form?.addEventListener('product:rerender', event => {
        // ProductRerender deliberately leaves galleries intact on variant changes.
        this.sync(event.detail.htmlFragment);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() { this.controller?.abort(); wakeFloating(); }

    syncMotionControl() {
      const button = this.querySelector('[data-fomo-motion-toggle]');
      if (!button) return;
      const paused = this.hasAttribute('data-motion-paused');
      if (button.getAttribute('aria-pressed') !== String(paused)) button.setAttribute('aria-pressed', String(paused));
      const title = paused ? 'Balkenanimation fortsetzen' : 'Balkenanimation pausieren';
      if (button.title !== title) button.title = title;
    }

    sync(root) {
      const match = Array.from(root.querySelectorAll('nn-fomo-bar')).find(bar => bar.dataset.fomoKey === this.dataset.fomoKey);
      if (!match) { this.hidden = true; this.removeAttribute('data-loading'); wakeFloating(); return; }
      // Compare server markup so a locally paused control does not cause needless replacements.
      if (this.contentHTML !== match.innerHTML) {
        this.innerHTML = match.innerHTML;
        this.contentHTML = match.innerHTML;
      }
      this.syncMotionControl();
      this.hidden = match.hidden;
      this.dataset.variantId = match.dataset.variantId;
      this.dataset.pdpStickyMode = match.dataset.pdpStickyMode || 'off';
      this.removeAttribute('data-loading');
      wakeFloating();
    }
  }

  customElements.define('nn-fomo-bar', NNFomoBar);

  document.addEventListener('visibilitychange', wakeFloating);
  window.addEventListener?.('scroll', wakeFloating, { passive: true });
  window.addEventListener?.('resize', wakeFloating, { passive: true });
  document.addEventListener('load', wakeFloating, true);
  document.fonts?.ready?.then(wakeFloating);
})();
